import React, { useState } from "react";

export default function TickerNoticeBar() {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 800);
  };

  const tickerItems = [
    { id: "075841", user: "Phạm Phương Anh", action: "được tạo bởi", detail: ", vui lòng xem xét và xác nhận" },
    { id: "PT22092026075651", type: "Có phiếu thu mới với mã", user: "Phạm Phương Anh", action: "được tạo bởi", detail: ", vui lòng xem xét và xác nhận" },
    { id: "DXNV2209202601", type: "Có một phiếu đề xuất nghiệp vụ", user: "Nguyễn Văn Minh", action: "vừa gửi duyệt", detail: ", vui lòng kiểm tra" }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200/80 p-3 px-4 flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3 text-sm transition-all duration-200">
      <div className="flex flex-wrap items-center gap-2 md:gap-3 shrink-0">
        <span className="font-bold text-gray-800 flex items-center gap-1.5 whitespace-nowrap">
          Hôm nay có gì?
        </span>

        <span className="inline-flex items-center gap-1 bg-red-600 text-white text-xs font-semibold px-2.5 py-0.5 rounded-full shadow-sm">
          <span className="w-1.5 h-1.5 bg-white rounded-full animate-ping" />
          1 bài viết mới
        </span>

        <button className="inline-flex items-center gap-1.5 border border-blue-500 text-blue-600 hover:bg-blue-50 text-xs font-medium px-2.5 py-0.5 rounded-full transition-colors">
          <svg className="w-3.5 h-3.5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          38976 thông báo chưa đọc
        </button>
      </div>

      {/* Middle ticker marquee */}
      {isExpanded && (
        <div className="flex-1 overflow-hidden relative mx-1 md:mx-4 py-1 bg-gray-50/60 rounded-lg px-3 border border-gray-100">
          <div className="whitespace-nowrap overflow-x-auto no-scrollbar flex items-center text-xs text-gray-600">
            {tickerItems.map((item, idx) => (
              <React.Fragment key={idx}>
                {idx > 0 && <span className="mx-3 text-gray-400 font-bold">•</span>}
                <span className="inline-flex items-center gap-1">
                  {item.type && <span>{item.type} </span>}
                  <span className="font-bold text-blue-700 hover:underline cursor-pointer">{item.id}</span>
                  <span> {item.action} </span>
                  <span className="font-semibold text-gray-800">{item.user}</span>
                  <span>{item.detail}</span>
                </span>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}

      {/* Right side date & actions */}
      <div className="flex items-center justify-between md:justify-end gap-2 text-xs text-gray-500 shrink-0">
        <span className="font-medium text-gray-600 bg-gray-100 px-2.5 py-1 rounded-md">
          22-09-2026
        </span>

        <button
          onClick={handleRefresh}
          title="Làm mới"
          className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
        >
          <svg
            className={`w-4 h-4 ${isRefreshing ? "animate-spin text-blue-600" : ""}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? "Thu gọn" : "Mở rộng"}
          className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
        >
          <svg
            className={`w-4 h-4 transition-transform duration-200 ${isExpanded ? "" : "rotate-180"}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}
